import React, { useState } from 'react';
import { Container, Box, Typography, Tabs, Tab, Alert } from '@mui/material';
import ThemeBackground from '../../components/Layout/ThemeBackground';
import PaymentDashboard from '../../components/admin/PaymentDashboard';
import PaymentConfig from '../../components/admin/PaymentConfig';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`payment-tabpanel-${index}`}
      aria-labelledby={`payment-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const PaymentSettings: React.FC = () => {
  const [value, setValue] = useState(0);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <ThemeBackground variant="full">
      <Container maxWidth="xl">
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom className="theme-text-primary">
          Payment Settings
        </Typography>
        <Typography variant="body1" className="theme-text-secondary">
          Manage your payment configuration and view transaction history
        </Typography>
      </Box>

      {successMessage && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccessMessage(null)}>
          {successMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setErrorMessage(null)}>
          {errorMessage}
        </Alert>
      )}

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'rgba(255, 255, 255, 0.1)' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="payment settings tabs"
            TabIndicatorProps={{
              style: {
                backgroundColor: 'rgba(100, 181, 246, 0.9)',
                height: '3px'
              }
            }}
            sx={{
              '& .MuiTab-root': {
                color: 'rgba(255, 255, 255, 0.9) !important',
                textTransform: 'uppercase',
                fontWeight: 500,
                fontSize: '0.875rem',
                letterSpacing: '0.5px',
                '&.Mui-selected': {
                  color: 'rgba(100, 181, 246, 1) !important'
                },
                '&:hover': {
                  color: 'rgba(255, 255, 255, 1) !important'
                }
              }
            }}
          >
            <Tab label="Configuration" />
            <Tab label="Transactions" />
          </Tabs>
        </Box>
        
        <TabPanel value={value} index={0}>
          <PaymentConfig 
            onSuccess={(msg: string) => setSuccessMessage(msg)}
            onError={(msg: string) => setErrorMessage(msg)}
          />
        </TabPanel>
        
        <TabPanel value={value} index={1}>
          <PaymentDashboard />
        </TabPanel>
      </Box>
    </Container>
    </ThemeBackground>
  );
};

export default PaymentSettings;
